import type { CSSProperties } from 'react';

/**
 * Pass CSS custom properties through React's `style` prop.
 *
 * Dynamic colours (per-account swatch, per-calendar colour) enter the CSS layer
 * as variables rather than as literal colours in a stylesheet — that is what
 * keeps the "no hardcoded colours in component CSS" rule intact.
 */
export function cssVars(vars: Record<string, string | number>, base?: CSSProperties): CSSProperties {
  return { ...base, ...vars } as CSSProperties;
}
